import styled from "styled-components";
import { colors } from "styles/theme";

export const Container = styled.div`
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
`;

export const FormSection = styled.div`
  padding: 1.5rem 0;
`;

export const SectionTitle = styled.h3`
  margin: 0 0 1rem 0;
  color: ${colors.neutral_darkest};
  font-size: 1.2rem;
`;

export const Wrapper = styled.div`
  display: flex;
  gap: 1rem;
  margin-bottom: 1rem;

  > div {
    flex: 1;
  }
`;
export const LogoWrapper = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 1rem;
  margin-bottom: 1rem;
`;

export const FormActions = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  margin-top: 2rem;
  background: ${colors.neutral_light};
  border-radius: 8px;
`; 